import React from 'react';
import googlePlayBadge from '../../Assets/Images/googlePlayBadge.svg'
import iosBadge from '../../Assets/Images/badge_appstore-lrg.svg'
import './style.scss';

const imageLinks = {
	ios: iosBadge,
	android: googlePlayBadge,
};

class MobileStoreButton extends React.Component {
	static defaultProps = {
		divClassName: 'default-dimension'
	};

	render() {
		const {
			store,
			url,
			divClassName,
			linkStyles,
			linkProps,
			...props
		} = this.props;

		const defaultLinkStyles = {
			background: `url(${imageLinks[store]}) no-repeat`,
			backgroundSize: 'contain',
			display: 'inline-block',
			overflow: 'hidden',
			textDecoration: 'none',
			height: '100%',
			width: '100%',
			padding: '5px',
			...linkStyles,
		};

		return (
			<div className={divClassName} {...props}>
				<a
					style={defaultLinkStyles}
					href={url}
					target="_blank"
					rel="noopener noreferrer"
					{...linkProps}
				>
					&nbsp;
				</a>
			</div>
		);
	}
}

export default MobileStoreButton;
